import React, { useEffect, useState } from 'react';
import notification from 'antd/lib/notification'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { calendar, cancel, exclametry_red_dark, indian_flag, Vector } from '../../assets/images';
import { Card, PackageSelector } from '../common/atoms';
import { handleAppError } from '../handlers';
import moment from 'moment';
import { employeeDataApi } from '../../services';
import { ALL_COUNTRIES_ISD_CODES } from '../../constants/overview';
import { dropdownDownArrow } from '../../assets/images'
import Dropdown from '../common/atoms/Dropdown';
import { dsButtonDisabledPrimary, dsButtonPrimary, joinButtonClasses } from '../../utils/buttonStyles';

const BookAppointmentModal = ({ employeeID, employeeName, employeeisdCode,employeeEmail, employeeMobileNumber, employeeGender, employeeDOB, BookAppointmentHandler }) => {
  const [state, setState] = useState({
    employees: [], loading: true, employeeID: employeeID, employeeName: employeeName, employeeGender: employeeGender, employeeMobileNumber: employeeMobileNumber,employeeisdCode: employeeisdCode,
    employeeEmail: employeeEmail, employeeDOB: employeeDOB, packageName: null, packageType: null,
    empUpdateError: true, packages: [], packageID: undefined,
    benefitType: 'ahc', benefitAvailed: false
  })
  const [openDropdown, updateOpenDropdown] = useState(false)
  const [isdCode, setIsdCode] = useState(state.employeeisdCode)

  const setSubState = (newState) => {
    setState(prevState => { return { ...prevState, ...newState } })
  }
 
  const updateSelectedItem = (item) => {
    setIsdCode(item.id)
    updateOpenDropdown(false)
  }

  //const contactNumber = isdCode !== '+91' ? (mobile || alternativeMobileNumber) : mobile
  const allCountryIsdCode = ALL_COUNTRIES_ISD_CODES.map(code => ({...code, disabled: ( code.id !== isdCode ) }))

  const dob = state.employeeDOB ? new Date(moment(state.employeeDOB, 'YYYY-MM-DD')) : null

  useEffect(() => {
    fetchPackages()
    fetchAvailStatus()
    setSubState({ loading: false })
  }, [])

  const fetchAvailStatus = () => {
    if (state.employeeID != null) {
      let url = window.API_URL + "corporate/customers/" + state.employeeID + "/benefits/appointments/utilization?benefit_type=" + state.benefitType + "&company_id=" + sessionStorage.getItem('company_id')
      window.axios.get(url)
        .then(function (response) {
          if(response.data){
          setSubState({ benefitAvailed: response.data.benefit_availed })}
        })
        .catch(function (error) {
          handleAppError(error)
          setSubState({loading: false})
        })
    }
  }

  const fetchPackages = () => {
    if (state.employeeID != null) {
      let url = window.API_URL + "corporate/customers/" + state.employeeID + "/benefits/appointments/packages?benefit_type=" + state.benefitType + "&company_id=" + sessionStorage.getItem('company_id')
      window.axios.get(url)
        .then(function (response) {
          if(response.data.packages){
          setSubState({ packages: response.data?.packages?.available_packages })}
          setSubState({loading: false})
        })
        .catch(function (error) {
          handleAppError(error)
          setSubState({loading: false})
        })
    }
  }

  const updateMobileHandler = (name, value) => {
    let validation = true
    if (true) {
      if (value.length === 0) {
        notification['error']({
          message: 'Mobile Number Should not be empty',
          description: "please enter mobile number"
        })
        validation = false
      }
      else if (isdCode === '+91' && !value.match(/^[6-9][0-9]{9}$/)) {
        notification['error']({
          message: 'Mobile number should be 10 digits and starts with [6-9]',
          description: "please enter valid mobile number"
        })
        validation = false;
      }
    }
    if (validation && value !== state.employeeMobileNumber) {
      changeHandler(name, value)
    }
  }

  const changeHandler = (name, value) => {
    setSubState({ employeeMobileNumber: value })
  }

  const updatePackageId = (value) => {
    const selectedPackage = state.packages.find(item => item.id === value);
    setSubState({ packageID: value, packageName: selectedPackage?.name , packageType: selectedPackage?.collection_type})
  };

  const validate = () => {
    if (state.employeeMobileNumber == null || state.employeeMobileNumber?.length === 0) {
      notification['error']({
        message: 'Mobile Number Should not be empty',
        description: "please enter mobile number"
      })
      return false
    }
    if (isdCode === '+91' && !state.employeeMobileNumber?.match(/^[6-9][0-9]{9}$/)) {
      notification['error']({
        message: 'Mobile number should be 10 digits and starts with [6-9]',
        description: "please enter valid mobile number"
      })
      return false
    }
    if (state.packageID == null) {
      notification['error']({
        message: 'Package should not be empty',
        description: "Please select package"
      })
      return false
    }
    if(state.employeeDOB === null){
      notification['error']({
        message: 'Date of Birth should not be empty',
        description: "Please enter Date of Birth"
      })
      return false
    }
    return true
  }

  const getInitials = (fullName) => {
    const names = fullName ? fullName.split(" ") : [];
    if (names.length > 2) {
      const firstInitial = names[0].charAt(0).toUpperCase();
      const lastInitial = names[names.length - 1].charAt(0).toUpperCase();
      return firstInitial + lastInitial;
    }
    const initials = names.map(name => name.charAt(0).toUpperCase());
    return initials.join("");
  }

  const buttonHandler = () => {
    if (validate()) {
      BookAppointmentHandler(state.employeeMobileNumber, state.packageID, state.packageName, state.packageType,isdCode)
    }
  }

  const formatUserInfo = () => {
    let formattedText = "";
    const email = state.employeeEmail
    const gender = state.employeeGender

    if (gender) {
      formattedText += gender + " · ";
    }
    if (email) {
      formattedText += email;
    }
    if (formattedText.endsWith(" · ")) {
      formattedText = formattedText.slice(0, -3);
    }
    return formattedText;
  }

  const cancelHandler = () => {
    if (!state.benefitAvailed) {
      setSubState({ employeeMobileNumber: '' })
    }
  }

  const updateDob = (date) => {

    let data = {
      id: state.employeeID, date_of_birth: date, email: state.employeeEmail
    }

    let options ={
      id: state.employeeID, data
    }

    employeeDataApi.update_employees(options,
      (resp) => {
        notification['success']({
          message: 'Date of Birth has been updated'
        })
      },
      (err) => {
        handleAppError(err)
      });
    fetchPackages();
  }

  const changeDOB = (value) => {
    let selectedDate = moment(value, 'YYYY-MM-DD').format('YYYY-MM-DD')
    setSubState({employeeDOB: selectedDate})
    updateDob(selectedDate)
  }

  const cancelDob = () => {
    setSubState({employeeDOB: null})
  }

  return (
    <div className=' pt-6 flex-col flex justify-between h-full' style={{ background: '#F9FAFB' }}>
     { !state.loading && <div className='px-6'>
        {state.benefitAvailed &&
          <Card
            svgsrc={exclametry_red_dark}
            title='Booking not allowed'
            subTitle='As the employee has already utilized this service for the authorised period. it is not possible to book the service on their behalf.'
            classes='border-red-100 bg-red-50 mb-6'
            svgClasses=''
          />
        }
        <div className='bg-white h-16 flex border rounded-md items-center' >
          <div className='rounded-full border flex justify-center items-center text-center m-2' style={{ background: '#E6F3F0', width: '2.5rem', height: '2.5rem' }}>
            <div className='font-bold text-base'>{getInitials(state.employeeName)}</div>
          </div>
          <div className='m-2 flex-column justify-between justify-items-center items-center'>
            <div className='font-bold text-lg leading-5'>{state.employeeName}</div>
            <div className='text-sm text-gray-500'>{formatUserInfo()}</div>
          </div>
        </div><div className='text-xs font-semibold tracking-widest leading-3 text-gray-500 mt-3 mb-2'>DOB</div>
          <div className={`flex bg-white items-center border-gray-200 border justify-between mr-2 rounded py-1 w-full rounded-md`}>
            <div className='flex item-center'>
            <img src={calendar} style={{ width: 14 }} alt='calender' className=' mx-4'/>
            <DatePicker 
              onChange={(e) => changeDOB(e)}
              selected={dob}
              placeholderText="DD-MM-YYYY"
              dateFormat="dd/MM/yyyy"
              showYearDropdown
              showMonthDropdown 
              className={`dob border-gray-200 text-gray-700 placeholder-gray-300 ${state.benefitAvailed ? 'cursor-not-allowed' : 'cursor-pointer'}`}
              disabled={state.benefitAvailed}
              dropdownMode="select"
              useShortMonthInDropdown
              popperPlacement="bottom-start"
            />
            </div>
          
          {!(state.employeeDOB == null || state.employeeDOB == '') && <img src={cancel} className={`h-5 mr-4 ${state.benefitAvailed ? 'cursor-not-allowed' : 'cursor-pointer'}`} onClick={() => { cancelDob() }} disabled={state.benefitAvailed} />}
        </div>
        {(state.employeeDOB == null || state.employeeDOB == '') && <div className='mr-2 mt-1 text-xs tracking-wide text-gray-400'>DOB is mandatory to book an appointment</div>}
        <div className='text-xs font-semibold tracking-widest leading-3 text-gray-500 mt-3'>PHONE NUMBER</div>
        <div className={`w-full mt-2 p-1 flex items-center  border border-gray-200 bg-white rounded-md text-gray-700 ${state.benefitAvailed ? 'cursor-not-allowed' : ''}`}>
          <div className='w-1/5 mr-2'>
            <Dropdown
              selectedItem={isdCode} toggleList={()=>updateOpenDropdown(!openDropdown)} listOpen={openDropdown} 
              onChange={updateSelectedItem} list={allCountryIsdCode} title={isdCode} padding={"12px 8px 12px 10px"}
              dropDownIcon={dropdownDownArrow}  fontSize={'14px'} closeOnClickOverlay={true}
              marginTopOptions={'8px'} borderRequired={true} isdisable={state.benefitAvailed }
            />
          </div>
          <div className='flex justify-start justify-between w-full'>
            <input type='number' name='phone_number' value={state.employeeMobileNumber} placeholder='Enter Mobile Number'
              onBlur={(e) => {
                let { name, value } = e.target
                updateMobileHandler(name, value)
              }}
              onChange={(e) => {
                let { name, value } = e.target
                var letters = /^[0-9]*$/;
                if (!value.match(letters)) return false
                value = (value === ' ' ? value.trim() : value)
                changeHandler(name, value)
              }}
              disabled={state.benefitAvailed}
              style={{ borderColor: 'transparent' }}
              className={`location placeholder-gray-300 text-base font-semibold py-1 px-0 text-gray-700 width-full ${state.benefitAvailed ? 'cursor-not-allowed' : ''}`} />
          </div>
          {!(state.employeeMobileNumber == null || state.employeeMobileNumber == '') && <img src={cancel} className={`h-5 mr-3 ${state.benefitAvailed ? 'cursor-not-allowed' : 'cursor-pointer'}`} onClick={() => { cancelHandler() }} disabled={state.benefitAvailed} />}
        </div>
        {(state.employeeMobileNumber == null || state.employeeMobileNumber == '') && <div className='mr-2 mt-1 text-xs tracking-wide text-gray-400'>Phone Number is mandatory to book an appointment</div>}
        <div className='flex-column box-border overflow-hidden'>
          <div className='text-xs font-semibold tracking-widest leading-3 text-gray-500 mt-3 mb-2'>PACKAGES</div>
            <PackageSelector options={state.packages} handleSelect={updatePackageId} disabled={state.benefitAvailed}/>
        </div>
      </div>}
      <div className='bg-white h-20 flex justify-center' style={{ boxShadow: '0px -2px 10px #E5E8F0' }}>
        <button
          disabled={state.benefitAvailed || state.packageID == null || state.employeeDOB == null || state.employeeMobileNumber == null || state.employeeMobileNumber == ''}
          onClick={buttonHandler}
          className={joinButtonClasses(
            dsButtonPrimary,
            'mx-3 my-4 h-11 w-full',
            (state.benefitAvailed || state.packageID == null || state.employeeDOB == null || state.employeeMobileNumber == null || state.employeeMobileNumber == '') && dsButtonDisabledPrimary
          )}
        >
          Next choose an address
        </button>
      </div>
    </div>
  )
}

export default BookAppointmentModal
